import { useFormContext } from 'react-hook-form';

import { FormField, FormSelect } from '@/_components';

import { shirtSizePreferenceOptions } from './schema';

export function ShirtSizePreferenceInput({ isEditable }: { isEditable?: boolean }) {
  const form = useFormContext();

  return (
    <FormField
      control={form.control}
      name="t_shirt_size"
      render={({ field: { value, onChange } }) => (
        <FormSelect
          disabled={!isEditable}
          value={value}
          getOptionLabel={(option) => option.name}
          onChange={onChange}
          options={shirtSizePreferenceOptions}
          label="T-Shirt Size"
        />
      )}
    />
  );
}
